import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import PolarisMappingForm from "./PolarisMappingForm";

function PolarisCredentialsForm(props, ref) {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      required: true,
      rules: [urlRegexValidator],
    },
    {
      name: "accessToken",
      label: "Access Token",
      type: FieldTypes.PASSWORD,
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={PolarisMappingForm}
      initialValue={{ apiEndpoint: 'https://polaris.synopsys.com/api' }}
    />
  );
}

export default forwardRef(PolarisCredentialsForm);
